export const BackendLinks = {
    ["api"]: "https://api.marketspy.au:8443",
    ["ws"]: {host: "ws.marketspy.au", port: 443},
    ["pairs"]: "https://assets.marketspy.au/pairs.txt"
}
